import * as React from "react";
import { IconProps } from "../types";

const WindowChartLineOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <polyline
          points="4.75 12 6.5 10 7.5 11.25 9.5 7.75 11 10.25 13.25 5.75"
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="1.75"
          y="2.75"
          width="14.5"
          height="12.5"
          rx="2"
          ry="2"
          fill="none"
          transform="translate(18 18) rotate(180)"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="4.25" cy="5.25" r="0.75" fill={color} />
        <circle cx="6.75" cy="5.25" r="0.75" fill={color} />
      </svg>
    );
  },
);

export default WindowChartLineOutlineIcon;
